import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//Props Validations
import PropTypes from "prop-types";

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";
import FragranceDriverTab from "../components/fragranceDriver/FragranceDriverTab";
import FragranceDriverTable from "components/fragranceDriver/FragranceDriverTable";

// api
import api from "api/api";

import { useSelector } from "react-redux";

function FragranceDriver({ headerTitle = "" }) {
    const navigate = useNavigate();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const [isLoading, setIsLoading] = useState(false);

    // Bucket selection (shared with FragranceDriverTab and table's Reset button)
    const [selectedBucket, setSelectedBucket] = useState(null);

    const [bucketKPIs, setBucketKPIs] = useState({});

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    
    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
        textAnalysis: true,
        fragranceDriver: true,
    });
    // Navigation buttons for Hair Care
    const btnArr = isHairCare ? ["overallKpi", "agreementKpi", "justRight", "claims", "correlation"] : ["overallKpi", "agreementKpi", "claims"];

    useEffect(() => {
        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            setIsLoading(false);
        }
    }, [selectedStudy, navigate]);

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };

    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;

        _selectedStudies.forEach((each) => {
            if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                disabled = false;
            } else {
                disabled = true;
            }
        });

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy]);

    // Fetch fragrance driver KPIs from the backend whenever selected studies change
    useEffect(() => {
        if (selectedStudy.length === 0) return;

        const coreDataIds = selectedStudy.map((s) => s.id).join(",");
        const url =
            process.env.REACT_APP_SERVER_PATH +
            `/driver-analysis-output/fragrance-driver-kpis/?core_data_ids=${coreDataIds}`;

        setIsLoading(true);
        api
            .get(url)
            .then((res) => {
                const data = res?.data || {};
                setBucketKPIs(data);
            })
            .catch((error) => {
                console.error("Failed to fetch fragrance driver KPIs:", error);
                setBucketKPIs({});
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [selectedStudy]);

    return (
        <>
            {isLoading && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>

            <div
                style={{
                    minHeight: "calc(100vh - 170px)",
                    padding: "20px",
                    margin: "20px",
                    marginTop: "35px",
                }}
                className="full-container m-4 background-color-white box-shadow--full-container"
            >
                {/* Back Button */}
                <div
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 10,
                    }}
                >
                    <Link to="/studies">
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -35,
                                left: -35,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>

                {/* Fragrance Driver Tab Component */}
                <div
                    style={{
                        paddingLeft: "25px",
                        marginBottom: "15px",
                    }}
                >
                    <FragranceDriverTab
                        selectedBucket={selectedBucket}
                        setSelectedBucket={setSelectedBucket}
                    />
                </div>

                {/* Fragrance Driver Table */}
                <div
                    style={{
                        minHeight: "calc(100vh - 380px)",
                    }}
                >
                    <FragranceDriverTable
                        selectedBucket={selectedBucket}
                        onReset={() => setSelectedBucket(null)}
                        bucketKPIs={bucketKPIs}
                    />
                </div>

                {/* Main Navigation */}
                <div
                    style={{
                        position: "relative",
                        top: "62px",
                        height: "90px",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        btnDisabledObj={btnDisabled}
                    />
                </div>
            </div >
        </>
    );
}

// Typechecking props for the FragranceDriver
FragranceDriver.propTypes = {
    headerTitle: PropTypes.string,
};

export default FragranceDriver;
